module.exports = __webpack_public_path__ + "img/5.28a07de5.jpg";